export default __webpack_public_path__ + "static/emphasise-metric-dont-41b8007e431fedea284f51404adf9e274cce640242beed92ba43a3afc299f42e.png";